import React from "react";
import "./OurStory.css";
import { Container, Col, Row } from "react-bootstrap";
function OurStory() {
  return (
    <>
      <section className="our-story-block">
        <Container>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <div className="our-story-inner arrow-main">
                <h2>Our Story</h2>
                <p>
                 For more than three decades, our primary business has been providing investment and trading solutions. Mr. J. U. Mansukhani, an ex-IES officer and U.N.O. advisor with decades of capital market experience, founded our group in 1988. "Moneysukh" in 1988 was established as a small broking unit ran by a few people to serve a limited number of clients and aid them in developing their public market assets. Continuing his heritage, from 1988 till today we have always attempted to reinvent ourselves not just in terms of technology, but also from the viewpoint of the user. As a result, we have lately emerged as one of the fastest-growing fintech businesses. Customers began approaching us as a result of our considerable market presence. In terms of our philosophy, we think that client is always the King. As a result, our major aim has always been to increase our clients' wealth. We take pride in offering our current and prospective clients with the best-in-class experience possible, using cutting-edge technology and a dedicated team. We have remained at the vanguard of innovation, and we will continue to create for the prosperity of all clients associated with us.
                </p>
                
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default OurStory;
